import { defineMessages } from "react-intl"

export default defineMessages({
  myProfile: {
    id: "app.pages.NavBar.myProfile",
    defaultMessage: "MY PROFILE",
  },
  contactUs: {
    id: "app.pages.NavBar.contactUs",
    defaultMessage: "CONTACT US",
  },
  faq: {
    id: "app.pages.NavBar.faq",
    defaultMessage: "FAQ",
  },
  createProfil: {
    id: "app.pages.NavBar.createProfil",
    defaultMessage: "Create Profil",
  },
  logout: {
    id: "app.pages.NavBar.logout",
    defaultMessage: "Logout",
  },
  login: {
    id: "app.pages.NavBar.login",
    defaultMessage: "LOGIN",
  },
  home: {
    id: "app.pages.NavBar.home",
  },
  setCookies: {
    id: "app.pages.Footer.setCookies",
  }
})
